export default {
  unprocessedData: '還有未處理的記錄',
  pls_select: '請選擇',
  pls_input: '請輸入',
  pls_input_name_pinyin: '請輸入姓名拼音',
  max: '申請金額不得大於賬戶餘額',
  min: '申請金額不得小於0',
  correctAmount: '請輸入正確的金額',
  doSuccess: '操作成功',
  doError: '更新失敗，請聯繫客服人員',
  otherAccount: {
    getApplyRecordError: '獲取申請記錄出錯，請聯繫客服',
    applyTradeAccountTypeListError: '獲取申請賬戶信息出錯，請聯繫客服'
  }
}
